import { PayloadAction } from '@reduxjs/toolkit';
import {
  BatchStateRequest,
  BatchStateResponse,
  CheckBatchHistoryRequest,
  CheckBatchHistoryResponse,
  amlbotAPI,
} from '@/api';
import { SagaIterator } from '@/redux-saga';
import { call, put } from 'redux-saga/effects';
import { checkBatchActions } from '@/redux/actions';
import { parseError } from '@/redux/helpers';
import { checkBatchMappers } from '@/redux/mappers';

function* fetchCheckBatchHistory(
  action: PayloadAction<CheckBatchHistoryRequest>,
): SagaIterator {
  try {
    const { payload } = action;
    const response: CheckBatchHistoryResponse = yield call(
      amlbotAPI.fetchBatchHistory,
      payload,
    );
    const data = checkBatchMappers.checkBatchHistory(response);

    yield put(checkBatchActions.setData(data));
  } catch (error: unknown) {
    const { message } = parseError(error);
    yield put(checkBatchActions.setError(message));
  } finally {
    yield put(checkBatchActions.setLoading(false));
  }
}

function* refreshBatchItem(
  action: PayloadAction<BatchStateRequest>,
): SagaIterator {
  try {
    const { payload } = action;
    const response: BatchStateResponse = yield call(
      amlbotAPI.refreshBatchItem,
      payload,
    );

    const item = checkBatchMappers.mapBatchItem(response.data.batch);
    yield put(checkBatchActions.refreshDataItem(item));
  } catch (error: unknown) {
    const { message, errorCode } = parseError(error);
    // Optionally handle errorCode - ErrorCodeEnum.FIELD_REQUIRED
    yield put(checkBatchActions.setError(message));
  } finally {
    yield put(checkBatchActions.setLoading(false));
  }
}

export { fetchCheckBatchHistory, refreshBatchItem };
